import * as r from '@typoas/runtime';
export enum BusinessSegment {
  HAIRDRESSER = 'hairdresser',
  BARBER = 'barber',
  NAILS = 'nails',
  AESTHETICS = 'aesthetics',
  SPA = 'spa',
  MASSAGE = 'massage',
  HAIR_REMOVAL = 'hair-removal',
  BEAUTICIAN = 'beautician',
}
export enum BusinessType {
  SHOP = 'shop',
  HOME = 'home',
  MOBILE = 'mobile',
  CHAIR_RENTAL = 'chair-rental',
  FREELANCER = 'freelancer',
}
export type CreateVenueParams = {
  businessName: string;
  businessType: BusinessType;
  businessSegments: BusinessSegment[];
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  address: VenueAddress;
  dedicatedSpace: boolean;
  password: string;
  acceptsMarketing: boolean;
  verificationCode?: string | null;
  leadId?: string | null;
  opportunityId?: string | null;
  gaSessionId?: string;
  token: string;
};
export type CreateVenueResponse = {
  jobId: string | null;
  errors: {
    type: ErrorType;
    key: string;
  }[];
};
export enum ErrorType {
  NOT_FOUND = 'NOT_FOUND',
  ID_MISMATCH = 'ID_MISMATCH',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  INVALID = 'INVALID',
}
export type GetJobStatusResponse = {
  status: JobStatus;
};
export type GetVenueResponse = {
  redirectURL: string | null;
};
export enum JobStatus {
  PENDING = 'pending',
  NOT_FOUND = 'notFound',
  SUCCESS = 'success',
  FAILURE = 'failure',
}
export type OpenApiModel = {
  /**
   * OpenAPI version
   * @example "3.0.3"
   */
  openapi: string;
  info?: {
    description?: string;
  };
  tags?: string[];
};
export type ShouldVerifyEmailResponse = {
  shouldVerifyEmail: boolean;
};
export type VenueAddress = {
  street: string;
  city: string;
  postalCode: string;
  countryCode: string;
};
export type VerifyCodeResponse = {
  success: boolean;
};
export type AuthMethods = {};
export function createContext<FetcherData>(
  params?: r.CreateContextParams<AuthMethods, FetcherData>,
): r.Context<AuthMethods, FetcherData> {
  return new r.Context<AuthMethods, FetcherData>({
    serverConfiguration: new r.ServerConfiguration('/ssi-api', {}),
    authMethods: {},
    ...params,
  });
}
/**
 * OpenAPI schema url
 * Tags: supervision
 */
export async function v1SupervisionOpenapiGenerateDocs<FetcherData>(
  ctx: r.Context<AuthMethods, FetcherData>,
  params: {},
  opts?: FetcherData,
): Promise<OpenApiModel> {
  const req = await ctx.createRequest({
    path: '/ssi-api/supervision/openapi/openapi.json',
    params,
    method: r.HttpMethod.GET,
  });
  const res = await ctx.sendRequest(req, opts);
  return ctx.handleResponse(res, {});
}
/**
 * OpenAPI ui
 * You can provide any schema file in query param
 * Tags: supervision
 */
export async function v1SupervisionOpenapiUi<FetcherData>(
  ctx: r.Context<AuthMethods, FetcherData>,
  params: {
    url?: string;
  },
  opts?: FetcherData,
): Promise<unknown> {
  const req = await ctx.createRequest({
    path: '/ssi-api/supervision/openapi/ui',
    params,
    method: r.HttpMethod.GET,
    queryParams: ['url'],
  });
  const res = await ctx.sendRequest(req, opts);
  return ctx.handleResponse(res, {});
}
/**
 * Tags: venue
 */
export async function v1VenueCreateVenue<FetcherData>(
  ctx: r.Context<AuthMethods, FetcherData>,
  params: {
    lp_partners?: string;
  },
  body: CreateVenueParams,
  opts?: FetcherData,
): Promise<CreateVenueResponse> {
  const req = await ctx.createRequest({
    path: '/ssi-api/venue/sign-up',
    params,
    method: r.HttpMethod.POST,
    body,
  });
  const res = await ctx.sendRequest(req, opts);
  return ctx.handleResponse(res, {});
}
/**
 * Tags: venue
 */
export async function v1VenueGetJobStatus<FetcherData>(
  ctx: r.Context<AuthMethods, FetcherData>,
  params: {
    jobId: string;
  },
  opts?: FetcherData,
): Promise<GetJobStatusResponse> {
  const req = await ctx.createRequest({
    path: '/ssi-api/venue/job/{jobId}',
    params,
    method: r.HttpMethod.GET,
  });
  const res = await ctx.sendRequest(req, opts);
  return ctx.handleResponse(res, {});
}
/**
 * Tags: venue
 */
export async function v1VenueGetVenue<FetcherData>(
  ctx: r.Context<AuthMethods, FetcherData>,
  params: {
    email: string;
    token: string;
  },
  opts?: FetcherData,
): Promise<GetVenueResponse> {
  const req = await ctx.createRequest({
    path: '/ssi-api/venue',
    params,
    method: r.HttpMethod.GET,
    queryParams: ['email', 'token'],
  });
  const res = await ctx.sendRequest(req, opts);
  return ctx.handleResponse(res, {});
}
/**
 * Tags: venue
 */
export async function v1VenueShouldVerifyEmail<FetcherData>(
  ctx: r.Context<AuthMethods, FetcherData>,
  params: {
    email: string;
    token: string;
  },
  opts?: FetcherData,
): Promise<ShouldVerifyEmailResponse> {
  const req = await ctx.createRequest({
    path: '/ssi-api/venue/should-verify-email',
    params,
    method: r.HttpMethod.GET,
    queryParams: ['email', 'token'],
  });
  const res = await ctx.sendRequest(req, opts);
  return ctx.handleResponse(res, {});
}
export async function v1VerificationSendVerificationCode<FetcherData>(
  ctx: r.Context<AuthMethods, FetcherData>,
  params: {
    email: string;
    token: string;
    firstName: string;
    lastName: string;
    businessName: string;
    language: string;
  },
  opts?: FetcherData,
): Promise<unknown> {
  const req = await ctx.createRequest({
    path: '/ssi-api/verification/send',
    params,
    method: r.HttpMethod.GET,
    queryParams: [
      'email',
      'token',
      'firstName',
      'lastName',
      'businessName',
      'language',
    ],
  });
  const res = await ctx.sendRequest(req, opts);
  return ctx.handleResponse(res, {});
}
/**
 * Tags: verification
 */
export async function v1VerificationVerifyCode<FetcherData>(
  ctx: r.Context<AuthMethods, FetcherData>,
  params: {
    email: string;
    code: string;
    token: string;
  },
  opts?: FetcherData,
): Promise<VerifyCodeResponse> {
  const req = await ctx.createRequest({
    path: '/ssi-api/verification/verify',
    params,
    method: r.HttpMethod.GET,
    queryParams: ['email', 'code', 'token'],
  });
  const res = await ctx.sendRequest(req, opts);
  return ctx.handleResponse(res, {});
}
